<template>
  <div
      class="video-card"
      :class="{'featured': video.is_featured}"
      @click="show()"
  >
    <div
      class="video-card-landscape"
      :class="[
        {'d-none': orientation == 'portrait'},
        {'d-lg-none': orientation == 'both'}
      ]"
    >
      <div class="video-image-wrap">
        <div class="video-image" :style="`background-image:url('${imageUrl}');`">
          <span class="video-length">{{ video.length }}</span>
        </div>
      </div>
      <div class="video-details-wrap pl-3">
        <div class="video-title mb-1">{{ video.title }}</div>
        <div class="video-meta">
          <span>{{ video.publish_on | moment("M/D/YYYY") }}</span>
<!--          <span class="bullet mx-1">&bull;</span>-->
<!--          <span>{{ video.views }} views</span>-->
        </div>
      </div>
    </div>
    <div
      class="video-card-portrait"
      :class="[
        {'d-none': orientation == 'landscape'},
        {'d-none d-lg-block': orientation == 'both'}
      ]"
    >
      <div class="video-image-wrap">
        <div class="video-image" :style="`background-image:url('${imageUrl}');`">
          <span class="video-featured" v-if="video.is_featured">Featured</span>
          <span class="video-length">{{ video.length }}</span>
        </div>
      </div>
      <div class="video-details-wrap pt-3">
        <div class="video-title mb-1">{{ video.title }}</div>
        <div class="video-meta">
          <span>{{ video.publish_on | moment("M/D/YYYY") }}</span>
<!--          <span class="bullet mx-1">&bull;</span>-->
<!--          <span>{{ video.views }} views</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    video: { type: Object, required: true },
    orientation: { type: String, default: "both" }
  },
  computed: {
    imageUrl() {
      return !!this.video.image ? this.video.image.url : "";
    }
  },
  methods: {
    show() {
      this.goToRoute("videos.show", { video: this.video.id });
    }
  }
};
</script>
